export default {"src":"/_next/static/media/build-icon.e61400be.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};